import * as CL from '@design-system/component-library';
import { useFormContext } from 'react-hook-form';
import { dsClass } from '../../common/constants/dsClasses';
import { cancelMsg, confirmMsg, t } from '../../common/i18n';
import { SubscriptionPbxConfiguration } from '../../generated/api/subscriptionPbxConfiguration';
import { SubscriptionPbxDetails } from '../../generated/api/subscriptionPbxDetails';
import { MobileActiveChain } from './components/MobileActiveChain';
import { MobileCallDetails } from './components/MobileCallDetails';
import { MobileRespondentList } from './components/MobileRespondentList';
import { MobileWorkingHours } from './components/MobileWorkingHours';
import type { ReachabilityWithMobileFormValues } from '../PbxAccordionContent/PbxAccordionUtils';

import '../PbxAccordionContent/PbxAccordionContent.scss';

interface ReachabilityWithMobileEditProps {
  setEditing: (editing: boolean) => void;
  isSaving: boolean;
}

export const ReachabilityWithMobileEdit = ({ setEditing, isSaving }: ReachabilityWithMobileEditProps) => {
  const { watch, reset, clearErrors } = useFormContext();
  const addonAttributes = watch() as ReachabilityWithMobileFormValues;

  const showConnectToNumber =
    addonAttributes.busyAction === SubscriptionPbxConfiguration.BusyActionEnum.CONNECT_TO_NUMBER;
  const showWorkingHours =
    addonAttributes.currentActiveChain === SubscriptionPbxDetails.CurrentActiveChainEnum.CALENDAR;

  return (
    <div className="of-pbx-accordion-content">
      <MobileActiveChain addonAttributes={addonAttributes} edit={true} clearErrors={clearErrors} />
      {showWorkingHours && <MobileWorkingHours addonAttributes={addonAttributes} edit={true} />}
      <MobileRespondentList edit={true} />
      <MobileCallDetails edit={true} showConnectToNumber={showConnectToNumber} />

      <div className={dsClass.PADDING_BOTTOM_3}>
        <CL.Button size="l" type="submit" loading={isSaving}>
          {t.QVYK(confirmMsg)}
        </CL.Button>
        <CL.Button
          onClick={() => {
            setEditing(false);
            reset();
          }}
          size="l"
          color="link"
        >
          {t.B2V1(cancelMsg)}
        </CL.Button>
      </div>
    </div>
  );
};
